/*!
 * el-table-infinite-scroll v3.0.6
 * (c) 2019-2024 yujinpan
 */

import _ElTableInfiniteScroll from './el-table-infinite-scroll.js';

var ElTableInfiniteScroll = Object.assign(_ElTableInfiniteScroll, {
  install: function install(vue) {
    vue.directive('el-table-infinite-scroll', ElTableInfiniteScroll);
  }
});

export { ElTableInfiniteScroll as default };
